export function isFrontendAppEmbedded(): boolean {
  return window.__POWERED_BY_QIANKUN__;
}
